import React, {Component} from 'react';
import Head from '../../../Structure/components/Head/Head';
import {Link} from 'react-router';
import {PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN} from "../../../../App/RouterAdopta";

export default class RegistroEmailVerificadoPage extends Component {

    constructor(props) {
        super(props);

        //console.log(props)
    }

    render() {
        const nombre = (this.props.location && this.props.location.query && this.props.location.query.protectoraVerificada) ? this.props.location.query.protectoraVerificada : undefined
        const email = (this.props.location && this.props.location.query && this.props.location.query.emailVerificado) ? this.props.location.query.emailVerificado : undefined
        const tipo = (this.props.location && this.props.location.query && this.props.location.query.tipo) ? this.props.location.query.tipo.charAt(0).toLowerCase() + this.props.location.query.tipo.slice(1) : undefined
        return (
            <div className="Homepage-banner">
                <Head
                    previousPath={"registro"}
                />
                <div className="page-login main-content">
                    <div className="container">
                        <div className="container-thanks">
                            <div className="container-text">
                                <h2>Genial{(nombre) ? " " + nombre + "!" : "!"}</h2>
                                <h5>Verificaste el email{(email) ? ": " + email + "" : ""}</h5>
                                <h6>Ya puedes iniciar sesión con este email y empezar a subir tus animales y mejorar las
                                    adopciones de
                                    tu{(tipo) ? " " + tipo + "" : " protectora"}</h6>
                            </div>

                            <div className="back-button">
                                <Link to={PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN + "?utm_medium=emailVerificado"}
                                      className="btn btn-outline-secondary btn-get-started">Ir al
                                    login</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        $('.index-resume__heading').show();
        //$('.header-topbar').css("visibility", "visible");
    }
}